module.exports = __webpack_public_path__ + "images/icons_v2/check-circle-filled-1b2c1100.svg";